import { render, staticRenderFns } from "./orderCreateYC.vue?vue&type=template&id=6b68e34b&scoped=true"
import script from "./orderCreateYC.vue?vue&type=script&lang=js"
export * from "./orderCreateYC.vue?vue&type=script&lang=js"
import style0 from "./orderCreateYC.vue?vue&type=style&index=0&id=6b68e34b&prod&lang=css"
import style1 from "./orderCreateYC.vue?vue&type=style&index=1&id=6b68e34b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b68e34b",
  null
  
)

export default component.exports